module.exports = __webpack_public_path__ + "static/media/bto-logo-portrait.6667c538.gif";